import { render } from "./BaseService.vue?vue&type=template&id=47a07625&scoped=true"
import script from "./BaseService.vue?vue&type=script&lang=js"
export * from "./BaseService.vue?vue&type=script&lang=js"

import "./BaseService.vue?vue&type=style&index=0&id=47a07625&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-47a07625"
/* hot reload */
if (module.hot) {
  script.__hmrId = "47a07625"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('47a07625', script)) {
    api.reload('47a07625', script)
  }
  
  module.hot.accept("./BaseService.vue?vue&type=template&id=47a07625&scoped=true", () => {
    api.rerender('47a07625', render)
  })

}

script.__file = "src/ui/services/BaseService.vue"

export default script